import { createSelector } from 'reselect'
import { IStore } from '../reducers'

const selectScheduleActions = (state: IStore) => state.schedule_stops

export const scheduleActionsSelector = createSelector(
  selectScheduleActions,
  scheduleStops => scheduleStops
)
